function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 12",
    style: {
      enableBackground: "new 0 0 20 12"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5D5D5D"
    },
    points: "20,6 18.4,4.5 18.4,4.5 13.59,0 11.99,1.5 15.73,5 0,5 0,7 15.73,7 11.99,10.5 13.59,12 18.4,7.5 18.4,7.5 "
  }));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow.7e0622d5.svg";
export { ForwardRef as ReactComponent };